import {make} from "vuex-pathify";
import router from "@/router";
import AppService from "@/services/app.service";
import i18n from "@/plugins/i18n";
import StaffService from "@/services/staff.service";
import {AgentSuggestionService} from "@/services";

const state = {
    suggestions: {},
    chosen_intent: "",
    sample: "",
    me: StaffService.getMe(),
}

const mutations = make.mutations(state)

const actions = {
    ...make.actions(state),
    fetchSuggestions({commit}, cb) {
        const botCode = router.currentRoute.params.bot_code;
        const senderId = router.currentRoute.params.senderId;
        AgentSuggestionService.fetchSuggestion(botCode, {sender_id: senderId, content: state.sample})
            .then((res)=> {
                commit('SET_SUGGESTIONS', res.data)
                cb()
            })
            .catch((err)=> {
                cb(err)
                AppService.toastError(i18n.t('failed'))
            })
    },
    agentAction({getters}, isMarkReview=false) {
        const botCode = router.currentRoute.params.bot_code;
        AgentSuggestionService.agentAction(botCode, getters.savedData)
            .then(()=> {
                if (isMarkReview) {
                    AppService.toastSuccess(i18n.t('success'))
                }
            })
            .catch(()=> {
                AppService.toastError(i18n.t('failed'))
            })
    },
}

const getters = {
    savedData(state) {
        return {
            sample: state.sample,
            agent: {
                id: state.me.id,
                name: state.me.name,
                email: state.me.email
            },
            chosen_intent: state.chosen_intent,
            suggestions: state.suggestions
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
